import { action, makeObservable, observable } from 'mobx';
import { MainStore } from './MainStore';
import {
    IBreadcrumbData,
    IMixedMedia,
    IOrderModuleData,
    IResponseData,
    IShutterModule,
    IContextData,
    IBrickItem,
    IResponseDataRefresh,
    ICategory
} from './types';

class DataStore {
    mainStore: MainStore;
    contextData: IContextData;
    breadcrumb: IBreadcrumbData;
    mixedMedia: IMixedMedia;
    sortedBrickItems: IBrickItem[];
    orderModule: IOrderModuleData;
    shutterModule: IShutterModule;
    category: ICategory;

    constructor(initialData: IResponseData, store: MainStore) {
        this.mainStore = store;
        this.updateData(initialData);

        makeObservable(this, {
            contextData: observable,
            breadcrumb: observable,
            category: observable,
            mixedMedia: observable,
            orderModule: observable,
            shutterModule: observable,
            sortedBrickItems: observable,
            updateData: action.bound
        });
    }

    updateData(data: IResponseData) {
        this.contextData = data.contextData;
        this.breadcrumb = data.breadcrumb;
        this.category = data.category;
        this.mixedMedia = data.mixedMedia;
        this.orderModule = data.orderModule;
        this.shutterModule = data.shutterModule;
        this.sortedBrickItems = data.sortedBrickItems;
    }

    dataRefresh(fetchedDataRefresh: IResponseDataRefresh): void {
        // update mixed media object:
        const mmObjectToReplaceIndex = this.mixedMedia.sortedMixedMediaForBricks.findIndex(
            arrayItem => arrayItem.brickNo === fetchedDataRefresh.mixedMediaForBrick.brickNo);
        if (mmObjectToReplaceIndex !== -1) {
            this.mixedMedia.sortedMixedMediaForBricks[mmObjectToReplaceIndex] = { ...fetchedDataRefresh.mixedMediaForBrick };
            this.mainStore.mixedMediaStore.collectMediaOverlayImages();
        }

        // update item inside sortedBrickItems array:
        const sbiObjectToReplace = this.mainStore.dataStore.sortedBrickItems.find(
            (sbi) => sbi.brickItemNo === fetchedDataRefresh.brickItem.brickItemNo
                && sbi.brickNo === fetchedDataRefresh.brickItem.brickNo);

        if (sbiObjectToReplace) {
            Object.assign(sbiObjectToReplace, this.mainStore.variantStore.selectedBrickItem);
        }

        // update order module object:
        const sbsObjectToReplace = this.orderModule.sortedBrickSelections.find(
            it => it.brickNo === this.mainStore.variantStore.selectedBrickItem.brickNo);

        if (sbsObjectToReplace) {
            this.mainStore.dataStore.orderModule.flexSetPrice.price = fetchedDataRefresh.orderModule.price;
            this.mainStore.dataStore.orderModule.flexSetPrice.priceDeduction = fetchedDataRefresh.orderModule.priceDeduction;
            this.mainStore.dataStore.orderModule.flexSetPrice.originalPrice =
                fetchedDataRefresh.orderModule.originalPrice;
            this.mainStore.dataStore.orderModule.deliveryInformation = fetchedDataRefresh.orderModule.deliveryInformation;
            this.mainStore.dataStore.orderModule.availabilityState = fetchedDataRefresh.orderModule.availabilityState;
            if (!this.contextData.isMobile)
                this.mainStore.orderModuleStore.setSelectedBrickNo(this.mainStore.variantStore.selectedBrickItem.brickNo);

            // we'll keep the same amountOfItems if it isn't set
            if (fetchedDataRefresh.orderModule.brickSelection.amountOfItems < 1)
                fetchedDataRefresh.orderModule.brickSelection.amountOfItems = sbsObjectToReplace.amountOfItems;

            Object.assign(sbsObjectToReplace, fetchedDataRefresh.orderModule.brickSelection);
        }

        // update articleSetItemDescription:
        const articleSetItemDescription = this.shutterModule.productInfo.description.sortedArticleSetItemDescriptions
            .find(it => it.brickNo === fetchedDataRefresh.brickItem.brickNo);

        if (articleSetItemDescription) {
            Object.assign(articleSetItemDescription, fetchedDataRefresh.articleSetItemDescription);
        }
    }
}

export default DataStore;
